import React, {Component} from 'react';
import styles from './styles.css';

export default class InputText extends Component {
	render() {
		let {fullWidth, className, ...props} = this.props;
		className = className ? className : '';
		className += ' ' + styles['input-text'];

		if (fullWidth)
		{
			className += ' ' + styles['input-text_full-width'];
			delete props.fullWidth;
		}

		return (
			<input type="text" className={className} {...props} />
		);
	}
}